"use strict";

angular.module("vendor")
.component("productVariants", {
    templateUrl: require("./product-variants.component.html"),
    controller: ProductVariantsController,
    controllerAs: "productVariantsCtrl",
    bindings: {
        product: "=",
        form: "=",
        isProductInventoryAvailable: "<",
        setInventoryQuantityZero: "<"
    }
});

function ProductVariantsController(
    $scope, $timeout, $q, gettextCatalog, FlashBag, Language, common,
    CoreProductVariantService, ProductVariantsService, ProductService, ModalService
) {
    var _this = this;
    var promises = []
    $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
    $scope.isProductInventoryAvailable = _this.isProductInventoryAvailable;
    $scope.setInventoryQuantityZero = _this.setInventoryQuantityZero;

    Language.initializeScope($scope, "language", "locale");

    $scope.variantOptions = [];
    promises.push(
        ProductVariantsService.getOptions().then(function onSuccess(response) {
            $scope.variantOptions = response.data;
        })
    );

    this.getProductVariantName = function(optionValues) {
        return CoreProductVariantService.getProductVariantName($scope.variantOptions, optionValues);
    };

    this.refreshProductVariants = function() {
        var defaultInventoryQuantity = null;
        if ($scope.isProductInventoryAvailable && $scope.setInventoryQuantityZero) {
            defaultInventoryQuantity = 0;
        }
        $q.all(promises).then(function onSuccess() {
            if (!$scope.variantOptions.length) {
                return;
            }

            $timeout(function() {
                var selectedValues = [];
                angular.forEach($scope.variantOptions, function(option) {
                    if (option.selected && option.values.length) {
                        var optionValues = [];
                        angular.forEach(option.values, function(value) {
                            if (value.selected) {
                                optionValues.push(value.id);
                            }
                        });
                        if (optionValues.length) {
                            selectedValues.push(optionValues);
                        }
                    }
                });

                var variants = common.generateCombinations(selectedValues);
                var productVariantIndex = _this.product.product_variants.length;
                while (productVariantIndex--) {
                    var variantSelected = false;
                    var productVariant = _this.product.product_variants[productVariantIndex];
                    angular.forEach(variants, function(values) {
                        if (_.isEqual(productVariant.option_values.sort(), values.sort())) {
                            variantSelected = true;
                            return;
                        }
                    });
                    if (productVariant.id && !variantSelected) {
                        productVariant.removed = true;
                        productVariant.enabled = false;
                    }
                    else if (productVariant.id && variantSelected) {
                        productVariant.removed = false;
                        productVariant.enabled = true;
                    }
                    else if (!variantSelected) {
                        _this.product.product_variants.splice(productVariantIndex, 1);
                    }
                    else {
                        productVariant.removed = false;
                        productVariant.enabled = productVariant.initial_enabled;
                    }
                }

                angular.forEach(variants, function(values) {
                    var variantExist = false;
                    angular.forEach(_this.product.product_variants, function(productVariant) {
                        if (_.isEqual(productVariant.option_values.sort(), values.sort())) {
                            variantExist = true;
                            return;
                        }
                    });
                    if (!variantExist) {
                        _this.product.product_variants.push({
                            'option_values': values,
                            'values': values,
                            'image': {},
                            'sku': '',
                            'inventory_quantity': defaultInventoryQuantity,
                            'enabled': true,
                            'initial_enabled': true
                        });
                    }
                });
            });
        });
    };

    this.editProductVariant = function(productVariant) {
        if (!productVariant.id) {
            return;
        }

        $q.all(promises).then(function onSuccess() {
            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("./modals/product-variant.modal.html"),
                controller: "ProductVariantModalController",
                controllerAs: "productVariantModalCtrl",
                inputs: {
                    $attrs: {
                        productVariant: productVariant,
                        variantOptions: $scope.variantOptions,
                        isProductInventoryAvailable: $scope.isProductInventoryAvailable,
                        setInventoryQuantityZero: $scope.setInventoryQuantityZero
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(productVariantData) {
                    FlashBag.clearAll();
                    if (productVariantData) {
                        ProductVariantsService.updateProductVariant(productVariant.id, productVariantData)
                        .then(
                            function onSuccess(response) {
                                common.scrollToTop();
                                FlashBag.success(gettextCatalog.getString("Product variant was successfully updated."), true);
                                productVariant.image = response.data['image_upload'];
                                productVariant.upc = response.data['upc'];
                                productVariant.barcode_format_name = response.data['barcode_format_name'];
                                productVariant.sku = response.data['sku'];
                                productVariant.inventory_quantity = response.data['inventory_quantity'];
                                productVariant.enabled = response.data['enabled'];
                                refreshProductVariantOptionValues();
                            },
                            function onError(response) {
                                FlashBag.apiError(response);
                            }
                        );
                    }
                    modal.element.remove();
                });
            });
        });
    };

    function refreshProductVariantOptionValues() {
        $q.all(promises).then(function onSuccess() {
            if (!_this.product.id || !$scope.variantOptions.length) {
                return;
            }

            ProductVariantsService.getProductVariantOptionValues(_this.product.id)
            .then(function onSuccess(response) {
                var variantOptionValues = response.data['variant_option_values'];
                angular.forEach($scope.variantOptions, function(option) {
                    if (variantOptionValues.hasOwnProperty(option.id)) {
                        option.selected = true;
                        angular.forEach(option.values, function(value) {
                            value.selected = !!variantOptionValues[option.id].includes(value.id);
                        });
                    }
                });
            });
        });
    }

    this.deleteProductVariant = function(productVariantId) {
        return ProductVariantsService.deleteProductVariant(productVariantId);
    };

    this.onProductVariantDelete = function(productVariantId) {
        var index = _this.product.product_variants.map(function(o) {
            return o.id;
        }).indexOf(productVariantId);
        _this.product.product_variants.splice(index, 1);
        refreshProductVariantOptionValues();
    };

    this.removeProductVariant = function(index) {
        _this.product.product_variants.splice(index, 1);
    };

    $scope.$on("productFetched", function() {
        refreshProductVariantOptionValues();
    });
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-variants/product-variants.component.js
// module id = 914
// module chunks = 0